import * as React from "react";
import { forwardRef } from "react";
const SvgExpand01 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.6667 8.33333L17.5 2.5M17.5 7.5V2.5H12.5M8.33333 11.6667L2.5 17.5M2.5 12.5L2.5 17.5H7.5", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgExpand01);
export { ForwardRef as ReactComponent };
